<template>
  <div>
      <section class="our_blog_area p_120">
            <div class="container">
                <div class="main_title" v-html="content_section"></div>
                <!--div class="main_title">
                    <h2>Últimos posts nas nossas redes sociais</h2>
                    <p>Veja nossos últimos posts feitos nas nosssas redes sociais.</p>
                </div-->
                <div class="blog_inner row">
                    
                    
                    
                    <div class="col-lg-4" v-for="data in instagram_data">
                        <div class="o_blog_item">
                            <div class="blog_img">
                                <a :href=" `${data.permalink}`" target="_blank">
                                    <img class="img-fluid" :src="data.media_url" :alt="data.caption">
                                </a>
                            </div>
                            <div class="blog_text">  
                                <p v-if="data.caption" style="word-wrap: break-word">
                                    {{data.caption}}
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    
                </div>
            </div>
        </section>
  </div>
</template>

<script>

    import axios from 'axios';

    let axiosInstance = axios.create();
    let apiInstagramURL = "https://graph.instagram.com/me/media?fields=id,caption,permalink,%20media_url&access_token=IGQVJYQkZA2TGluUDNLWnNxNjRnM1M2Vjk5cElQbmR2bjNZAay1FdURicnN1NVZAiMWZAzaEc2WThVUUsxQjduQjBzV2ZAPcVY5VVpLTkdMSFdkbmFDWkZAaUmlsQnJKODQ5ZAG9LNDJvVTVITlRwQ1Q4clVteQZDZD";

    export default {
        
        name: 'Social',
        
        props: {
            content_section: String,
        },
        
        data: function () {
            return {
                instagram_data: []
            }
        },

        created() {

            axiosInstance.get(`${apiInstagramURL}`)
                .then(response => {
                    this.instagram_data = response.data.data;
                    for(let i = 6; i <= this.instagram_data.length; i++){
                        this.instagram_data.splice(i);
                    }
                })
                .catch(error => {
                    console.log(error);
                })

        },

        methods: {
            returnDatePTBR(unix_timestamp){
                var date = new Date(unix_timestamp*1000);
                var day = date.getDay();
                var month = date.getMonth();
                var year = date.getFullYear();
                //var hours = date.getHours();
                //var minutes = "0" + date.getMinutes();
                //var seconds = "0" + date.getSeconds();
                return day + '/' + month + '/' + year;
            },
            getUrlHash(tag){
                return `https://www.instagram.com/explore/tags/${tag}`;
            }
        }
    }
</script>

<style>

</style>